import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import styled from "styled-components";

const Item = styled.div`
  display: flex;
  height: 32px;
  border: 1px none;
  border-radius: 0.25rem;
  background: #e6e6e6;
  margin: 1em 0;
  text-align: center;
  align-items: center;
  cursor: move;
  &&&:hover {
    color: #3175af;
  }

  span {
    width: 10%;
  }

  label {
    cursor: inherit;
    width: 90%;
  }
`;

export default function PriorityModal(props) {
  const [items, setItems] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [draggedItem, setDraggedItem] = useState({});

  const elements = items.map((item, index) => {
    return (
      <Item
        id={item.id}
        key={item.id}
        draggable
        onDrag={(event) => onDrag(event, item)}
        onDragOver={(event) => onDragOver(event)}
        onDrop={(event) => onDrop(event)}
      >
        <span id={item.id}>{index + 1}</span>
        <label id={item.id}>{item.name}</label>
      </Item>
    );
  });

  useEffect(() => {
    setItems(props.items);
  }, [props.show]); //fire useEffect when props.show toggles.

  function onDrag(event, item) {
    event.preventDefault();
    setDraggedItem(item);
  }

  function onDragOver(event) {
    event.preventDefault();
  }

  async function onDrop(event) {
    event.preventDefault();

    const sourceIndex = items.findIndex((x) => x.id === draggedItem.id);

    //get the id of destination item.
    const destinationId = event.target.id;
    if (draggedItem.id === destinationId) {
      return;
    }

    //get destination object.
    const filteredItems = items.filter(function (item) {
      //Id of object in array is unique, it must always return single object if id is found.
      return item.id === destinationId;
    });

    //Get the object from filtered items.
    const destination = filteredItems[0];
    const destinationIndex = items.findIndex((x) => x.id === destination.id);

    //copy existing array to new one.
    const newItems = [...items];

    //now, switch objects.
    newItems[destinationIndex] = draggedItem;
    newItems[sourceIndex] = destination;

    //override items in state with new array.
    setItems(newItems);
  }

  async function onSave() {
    setIsSaving(true);
    await props.onSavePriority(items);
    setIsSaving(false);
  }

  return (
    <Modal show={props.show} onHide={props.onHide} backdrop="static">
      <Modal.Header>
        <Modal.Title>Order Priority</Modal.Title>
      </Modal.Header>
      <Modal.Body>{elements}</Modal.Body>
      <Modal.Footer>
        <Button
          className="btn btn-primary pull-right"
          disabled={isSaving}
          style={{ marginLeft: 10 }}
          onClick={() => {
            onSave();
          }}
        >
          Save
          {isSaving ? (
            <span>
              <i className="fa fa-spinner fa-spin" />
            </span>
          ) : (
            <span></span>
          )}
        </Button>
        <Button className="btn btn-secondary" onClick={props.onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
